import React, { useEffect, useState } from "react";
import { Button, Flex, Spin, Checkbox } from "antd";
import { instance } from "utils/axios";
import { useParams } from "react-router-dom";

export default function QpayBalance() {
  const getBase64Img = (item) => {
    return `data:image/pngs;base64,${item}`;
  };

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
    const [cloading, setCheckLoading] = useState(false);
  const [text, setText] = useState("");

  const [approve, setApprove] = useState(false);
  const [status, setStatus] = useState(null);
  let { guid } = useParams();
useEffect(() => {
 fetchQr()
  // Your logic here
}, []);
  const fetchQr = () => {
    setApprove(true);
    setLoading(true);
    instance({
      method: "post",
      url: `/applicant/balance/qpay/${guid}`,
    })
      .then((res) => {
        setData(res.data);
        setStatus(res.data?.status)
        // console.log(res.data)
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };
  const fetchCheck = () => {
   
    setCheckLoading(true);
    instance({
      method: "get",
      url: `/qpay/check/invoice/${data?.senderInvoiceId}`,
    })
      .then((res) => {
        setStatus(res.data);
        if(res.data=="success")
        setText('Төлөгдсөн')
        else{ setText("Төлөгдөөгүй");}
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setCheckLoading(false));
  };
  return loading ? (
    <div className="flex flex-col items-center mt-20">
      <Flex align="center" gap="middle">
        <Spin size="large" />
      </Flex>
    </div>
  ) : data ? (
    <div className="grid justify-center h-full grid-cols-12 gap-2 font-raleway ">
      <div className="col-span-12  p-4  flex  justify-center text-[20pt] md:text-[20pt] font-bold  text-primary leading-[1.38]">
        Сургалтын үлдэгдэл төлбөр
      </div>

      <div className="col-span-12 p-4 rounded-lg shadow md:col-start-4 md:col-span-3 h-70 bg-slate-100">
        <div className="p-2 italic font-bold text-center border-primary">
          Та интернэт банкаа ашиглан төлбөрөө төлнө үү. Та төлбөрөө төлснөөр
          бүртгэл баталгаажих болно.
        </div>
        <div className="p-2 italic font-bold border-primary">Нэр:</div>
        <div className="p-2 italic border-primary">
          {data?.applicant.firstName}
        </div>
        <div className="p-2 italic font-bold border-primary">
          Утасны дугаар:
        </div>
        <div className="p-2 italic border-primary">{data?.applicant.phone}</div>
        <div className="p-2 italic font-bold border-primary">Төлбөр</div>
        <div className="p-2 italic border-primary">Үлдэгдэл</div>
        <div className="p-2 italic font-bold text-right border-t-2 border-primary">
          Төлөх дүн: ₮{Number(data?.amount).toLocaleString()}
        </div>
      </div>
      <div className="col-span-12 p-4 rounded-lg shadow md:col-span-4 bg-slate-100">
        {status == "success" ? (
          <div className="col-span-12 mt-16 p-4  flex  justify-center text-[20pt] md:text-[20pt] font-bold  text-primary leading-[1.38]">
            Төлөгдсөн байна
          </div>
        ) : (
          <div className="flex-wrap justify-center w-full md:flex">
            <div className="justify-center w-full mt-2 md:flex ">
              <img
                src={getBase64Img(data?.qrImage)}
                className="w-full md:w-3/5 "
              ></img>
            </div>
            <div className="justify-center w-full mt-2 md:flex ">{text}</div>
            {cloading ? (
              <>
                {" "}
                <Spin size="small" />
              </>
            ) : (
              <Button
                type="primary"
                className="w-full mt-2 md:w-40"
                onClick={() => {
                  fetchCheck();
                }}
              >
                Гүйлгээ шалгах
              </Button>
            )}
            <div className="mt-4 md:hidden text-[16pt] flex justify-center  font-bold text-primary leading-[1.38]">
              Банкны аппликейшн
            </div>
            <div className="flex justify-center w-full mt-8 md:hidden ">
              <div className="grid grid-cols-12 gap-2">
                {data?.urls.map((e, i) => {
                  return (
                    <div
                      w="100%"
                      key={i}
                      onClick={() => {
                        window.open(e.link);
                      }}
                      p={2}
                      className="flex items-center col-span-4 gap-6 p-4 rounded-lg shadow md:col-span-2"
                    >
                      <img
                        borderradius="full"
                        w="50px"
                        h="50px"
                        alt="avatar"
                        src={e.logo}
                        style={{ height: 50 }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className="col-span-12  p-4  flex  justify-center text-[20pt] md:text-[20pt] font-bold  text-primary leading-[1.38]">
      Data not found
    </div>
  );
}
